import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { WSSState } from 'src/app/wss/wss.model';
import { callId } from 'src/app/wss/wss.selectors';
import { AddTask, SetTaksIndex } from '../training.actions';
import { TrainingState } from '../training.model';
import { playChanged } from '../training.selectors';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-sel-task',
  templateUrl: './sel-task.component.html',
  styleUrls: ['./sel-task.component.scss']
})
export class SelTaskComponent {
  _tasks: any[] = []
  @Output() close: EventEmitter<void> = new EventEmitter();

  btn: string = "Add Task"
  task_name: string = ""
  call_id: string | undefined
  subscriptions: any[] = []

  constructor(
    public trainingStore: Store<TrainingState>,
    public training_sevice: TrainingService,
    private wssState: Store<WSSState>,
  ) {
    this.subscriptions.push(this.wssState.select(callId).subscribe((call_id: string | undefined) => {
      if (this.call_id != call_id) {
        this.call_id = call_id
        this.btn = "Add Task"
      }
    }))
    this.subscriptions.push(this.trainingStore.select(playChanged).subscribe((play: any) => {
      console.log("playChanged " + new Date())
      if (play && play._id) {
        setTimeout(() => {
          this._tasks = play.tasks
        })
      }
    }))
  }
  ngOnDestroy() {
    this.subscriptions.forEach((s) => {
      s.unsubscribe();
    })
  }
  play(index: number) {
    this.trainingStore.dispatch(new SetTaksIndex(index))
  }
  closeIt() {
    this.close.emit()
  }
  async addTask() {
    if (this.btn == "Add Task") {
      this.btn = "Save"
    } else {
      if (this.task_name.length > 0) {
        this.trainingStore.dispatch(new AddTask(this.task_name))

      }
    }
  }
}
